import { createContext, useState } from "react";
import { setToken } from "services/ApiService";
import authService from "services/AuthService";

const jsonUser = window.sessionStorage.getItem('user')
const user = jsonUser ? JSON.parse(jsonUser) : null

const jsonContrato = window.sessionStorage.getItem('contrato')
const contrato = jsonContrato ? JSON.parse(jsonContrato) : null

// SDD 034 - lista de papeis de site elegiveis do usuario (idUsuarioPerfil/nome/idTipo), usada
// pra decidir se mostra "Trocar papel" no AdminNavbar. GET /auth/me (SDD 033) nao devolve essa
// lista - so o vinculo ativo - entao ela e guardada aqui a partir da resposta do desafio de
// login (POST /auth com mais de 1 vinculo de site) e repassada adiante em cada setToken().
const jsonPapeis = window.sessionStorage.getItem('papeis')
const papeisArmazenados = jsonPapeis ? JSON.parse(jsonPapeis) : []

const theme = window.localStorage.getItem('theme') || 'dark'

const initialState = {
  user,
  contrato,
  theme
}

export function useActions() {
  const [state, setState] = useState(initialState)

  const actions = {
    checkToken: async () => {
      const token = window.sessionStorage.getItem('token')
      if (token) {
        setToken(token)
        try {
          const res = await authService.me()
          const jsonPapeis = window.sessionStorage.getItem('papeis')
          const papeis = jsonPapeis ? JSON.parse(jsonPapeis) : []
          actions.setUser({
            ...res.data,
            token,
            papeis
          })

          if (state.contrato && state.contrato.userId != res.data.id)
            actions.setContrato(null)

          return true
        } catch (ex) {
          setToken(null)
          actions.setUser(null)
          window.sessionStorage.setItem('token', null)
          window.sessionStorage.setItem('user', null)
          return false
        }
      } else {
        return false
      }
    },
    // SDD 034 - `papeis` (opcional) e a lista de vinculos de site elegiveis do usuario, vinda do
    // desafio de login (POST /auth) ou repassada pelo proprio AdminNavbar numa troca de papel em
    // runtime - persistida a parte, porque /auth/me nao a devolve (ver comentario acima).
    setToken: async (token, papeis) => {
      if (token) {
        window.sessionStorage.setItem('token', token)
        setToken(token)
        const res = await authService.me()
        const papeisFinal = papeis !== undefined ? papeis : papeisArmazenados
        window.sessionStorage.setItem('user', JSON.stringify(res.data))
        window.sessionStorage.setItem('papeis', JSON.stringify(papeisFinal || []))
        window.sessionStorage.removeItem('contrato')
        actions.setUser({
          ...res.data,
          token,
          papeis: papeisFinal || []
        })
        actions.setContrato(null)
      } else {
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('user')
        window.sessionStorage.removeItem('contrato')
        window.sessionStorage.removeItem('papeis')
        actions.setUser()
        actions.setContrato(null)
      }
    },
    setUser: (user) => {
      setState(state => ({ ...state, user }))
    },
    setContrato: (contrato) => {
      if (contrato) 
        contrato.userId = state.user.id

      setState(state => ({ ...state, contrato }))
      if (contrato) 
        window.sessionStorage.setItem('contrato', JSON.stringify(contrato))
      else 
        window.sessionStorage.removeItem('contrato')
    },
    setTheme: (theme) => {
      window.localStorage.setItem('theme', theme)
      setState(state => ({ ...state, theme }))
    }
  }

  return { state, actions }
}

const AppContext = createContext({})

export default AppContext
